import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import MenuBtn from "components/fragments/MenuBtn";
import POSHeader from "components/POSHeader";
import CashBreakdownCounterModal from "pages/CashBreakdownCounterModal";
import { authHandler, posHandler } from "../../redux/handlers";
import { setUser } from "../../redux/slices/pos.slice";

export default function Menu() {
  const dispatch = useDispatch();
  const { businessSlug } = useParams();
  const [selectedMenuIndex, setSelectedMenuIndex] = useState(null);
  const [isMoneyDrawerModalOpen, setIsMoneyDrawerModalOpen] = useState(false);

  const [cashFloatData, setCashFloatData] = useState([]);
  const [totalCashFloat, setTotalCashFloat] = useState(0);
  const [cashFloatCount, setCashFloatCount] = useState(0);

  const [cashRemovalData, setCashRemovalData] = useState([]);
  const [totalCashRemoval, setTotalCashRemoval] = useState(0);
  const [cashRemovalCount, setCashRemovalCount] = useState(0);

  const menuItems = [
    {
      iconPath: "/img/icons/icon-deposit.svg",
      menuText: "นำเงินเข้า",
      is_hidden: true,
    },
    {
      iconPath: "/img/icons/icon-withdraw.svg",
      menuText: "นำเงินออก",
      is_hidden: true,
    },
    {
      iconPath: "/img/icons/icon-money-bag.svg",
      menuText: "ปิดยอด",
      is_hidden: false,
    },
    {
      iconPath: "/img/icons/icon-3d-box.svg",
      menuText: "คลังสินค้า",
      is_hidden: true,
    },
    {
      iconPath: "/img/icons/icon-chart.svg",
      menuText: "สรุปยอดขาย",
      is_hidden: true,
    },
    {
      iconPath: "/img/icons/icon-medal.svg",
      menuText: "สถิติที่น่าสนใจ",
      is_hidden: true,
    },
    {
      iconPath: "/img/icons/icon-report.svg",
      menuText: "รายงาน",
      is_hidden: true,
    },
    {
      iconPath: "/img/icons/icon-user.svg",
      menuText: "โปรไฟล์",
      is_hidden: true,
    },
    {
      iconPath: "/img/icons/icon-setting.svg",
      menuText: "ตั้งค่า",
      is_hidden: true,
    },
  ];

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const response = await dispatch(
          authHandler.getUserBusinessProfile(businessSlug)
        );

        if (response && response) {
          dispatch(setUser(response));
        }
      } catch (error) {}
    };

    fetchUserProfile();
  }, [businessSlug, dispatch]);

  const fetchCashFloatData = async () => {
    try {
      const branchPOSSellingId = localStorage.getItem("branchPOSSelling");
      if (branchPOSSellingId) {
        const response = await dispatch(
          posHandler.getCashFloat(businessSlug, branchPOSSellingId)
        );

        if (response) {
          setCashFloatData(response);
          setCashFloatCount(response.length);
          const totalCash = response.reduce((sum, item) => {
            return sum + (item.cash_total || 0);
          }, 0);
          setTotalCashFloat(totalCash);
        }
      }
    } catch (error) {
      setCashFloatData([]);
      setCashFloatCount(0);
      setTotalCashFloat(0);
    }
  };

  const fetchCashRemovalData = async () => {
    try {
      const branchPOSSellingId = localStorage.getItem("branchPOSSelling");
      if (branchPOSSellingId) {
        const response = await dispatch(
          posHandler.getCashRemoval(businessSlug, branchPOSSellingId)
        );

        if (response) {
          setCashRemovalData(response);
          setCashRemovalCount(response.length);
          const totalCash = response.reduce((sum, item) => {
            return sum + (item.cash_total || 0);
          }, 0);

          setTotalCashRemoval(totalCash);
        }
      }
    } catch (error) {
      setCashRemovalData([]);
      setCashRemovalCount(0);
      setTotalCashRemoval(0);
    }
  };

  const handleMenuItemClick = async (index) => {
    setSelectedMenuIndex(index);

    setCashFloatData([]);
    setCashFloatCount(0);
    setTotalCashFloat(0);
    setCashRemovalData([]);
    setCashRemovalCount(0);
    setTotalCashRemoval(0);

    if (index === 0) {
      await fetchCashFloatData();
    } else if (index === 1) {
      await fetchCashRemovalData();
    }

    setIsMoneyDrawerModalOpen(true);
  };

  return (
    <div>
      <POSHeader isNotify={true} />
      <div className="pl-[min(9.96vw,102px)] pt-[min(2.15vw,22px)]">
        <div className="text-18 font-[500] leading-[1.3] text-[#333]">เมนู</div>
        <div className="mt-[min(3.42vw,35px)] flex flex-wrap gap-[min(2.44vw,25px)]">
          {menuItems.map((item, index) => (
            <>{item.is_hidden === false && (
            <MenuBtn
              key={index}
              onClick={() => handleMenuItemClick(index)}
              className="aspect-[190/132] w-[min(18.55vw,190px)] shadow-menu-btn bg-[#FFF] menu-btn-active"
              content={
                <div className="flex flex-col items-center gap-[min(0.88vw,9px)]">
                  <img
                    className="aspect-square w-[min(5.57vw,57px)] object-contain"
                    src={item.iconPath}
                    alt={item.menuText}
                  />
                  <div className="text-20 text-[#333] font-[600]">
                    {item.menuText}
                  </div>
                </div>
              }
            />
            )}</>
          ))}
        </div>
      </div>

      <CashBreakdownCounterModal
        modalOpenObj={{
          modalOpen: isMoneyDrawerModalOpen,
          setModalOpen: setIsMoneyDrawerModalOpen,
        }}
        currentMenu={selectedMenuIndex}
        cashFloatData={cashFloatData}
        cashFloatCount={cashFloatCount}
        totalCashFloat={totalCashFloat}
        cashRemovalData={cashRemovalData}
        cashRemovalCount={cashRemovalCount}
        totalCashRemoval={totalCashRemoval}
      />
    </div>
  );
}
